import React from 'react'
import { CustomInput, FormGroup, Label } from 'reactstrap'

export interface CheckBoxProps {
  id: string | number
  checked: boolean
  onChange: (checked: boolean) => void
  label?: React.ReactNode
  disabled?: boolean
  className?: string
}

export const CheckBox: React.FC<CheckBoxProps> = ({
  id,
  checked,
  onChange,
  label = '',
  disabled = false,
  className,
}) => {
  return (
    <FormGroup css={{ margin: 0 }} className={className}>
      <CustomInput
        type="checkbox"
        id={id}
        checked={checked}
        label={label}
        disabled={disabled}
        onChange={(e) => {
          onChange(e.target.checked)
        }}
      />
    </FormGroup>
  )
}
